import { styled, TableBody } from '@mui/material';

export const StyledTableBody = styled(TableBody)(() => ({
  position: 'relative',
}));
